<template>
  <ul class="wpcm-pre-dfind-amt" v-if="amounts">
    <li
      v-for="(amnt) in amounts"
      :key="amnt"
      @click.prevent="store.amount = convert(amnt)"
    >
      <a
        href="#"
        :class="[
          'wpdonation-button',
          store.amount == convert(amnt) && 'active'
        ]"
      >
        {{ getSymbol() }}{{ convert(amnt) }}</a
      >
    </li>
  </ul>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useDonationFormsStore } from '../store';

const store = useDonationFormsStore();
const props = defineProps(['amounts', 'symbols', 'symbol']);
const lifeline_donation = globalThis.lifeline_donation;
const _ = globalThis._;

const setValue = (key, val) => {
  store[key] = val;
};
const getSymbol = () => {
  return (props.symbols[store.currency] != undefined) ? props.symbols[store.currency] : props.symbol
};
const convert = (amt) => {
  const { exchange_rates } = lifeline_donation
  const syb = getSymbol()
  if(_.get(exchange_rates, syb)) {
    return (_.get(exchange_rates, syb) * amt);
  }
  return amt
};

onMounted(() => {
  store.amount = null; // Ensure the amount is null on component mount
});
</script>